import * as Sentry from "@sentry/react";

import { isDevOrStaging } from "common/utilities/environment";

export const logger = {
  // error() will log the message to the console and also send it to Sentry.
  error: (message: string, error?: unknown) => {
    if (error) {
      Sentry.captureException(error, { extra: { message } });
    } else {
      Sentry.captureMessage(message, "error");
    }

    console.error(message, error);
  },
  // errorLocal() will log the message to the console but not send it to Sentry as an error breadcrumb.
  errorLocal: (...args: unknown[]) => {
    Sentry.addBreadcrumb({ message: args.join(" "), type: "error" });
    console.error(...args);
  },
  // warn() will log the message to the console and also send it to Sentry as a warning breadcrumb.
  warn: (message: string) => {
    Sentry.addBreadcrumb({ message, type: "warning" });
    console.warn(message);
  },
  // log() will log the message to the console and also send it to Sentry as an info breadcrumb.
  log: (message: string) => {
    Sentry.addBreadcrumb({ message, type: "log" });

    if (isDevOrStaging) {
      console.log(message);
    }
  },
};
